import { render, staticRenderFns } from "./ArtisanGroup.vue?vue&type=template&id=6b61512e&scoped=true"
import script from "./ArtisanGroup.vue?vue&type=script&lang=js"
export * from "./ArtisanGroup.vue?vue&type=script&lang=js"
import style0 from "./ArtisanGroup.vue?vue&type=style&index=0&id=6b61512e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b61512e",
  null
  
)

export default component.exports